import React, { Component, PropTypes } from 'react'
import SimCardDialog from './sim-card-dialog'
import SimCardExtraDialog from './sim-card-extra-dialog'
import SimCardActivateDialog from './sim-card-activate-dialog'
import Tooltip from '../tooltip'
import { lang } from '../../strings'
import { getApiUrl } from '../../utils/network'
import { format } from '../../utils/string'
import { formatDate } from '../../utils/date'
import Select from 'react-select'

export default class SimCard extends Component {
  constructor(props) {
    super(props)

    this.state = this.makeInitialState(props)
  }

  makeInitialState(props) {
    return {
      showDialog: false,
      showActivate: false,
      showExtraDialog: false,
      currentSimCard: props.simCardInfo.simCard,
    }
  }

  componentWillReceiveProps(nextProps) {
    let currentSimCard = this.props.simCardInfo.simCard
    let nextSimCard = nextProps.simCardInfo.simCard

    if (currentSimCard.id != nextSimCard.id) {
      this.setState({ currentSimCard: nextSimCard })
    }
  }

  render() {
    let { simCardInfo, simCardTasks, extraSimCardTasks, customerType } =
      this.props
    let { simCardPrice, extraSimCardPrice, simCard, extraSimCards } =
      simCardInfo
    let { showDialog, showExtraDialog, showActivate, currentSimCard } =
      this.state
    let { id, iccId, pinCode, pukCode } = currentSimCard

    let isMainSimCard = currentSimCard.id === simCard.id
    let hasSimCardTask = simCardTasks && simCardTasks.length > 0
    let hasExtraSimCardTask = extraSimCardTasks && extraSimCardTasks.length > 0
    let canOrderSimCard = isMainSimCard && !hasSimCardTask
    let canOrderExtraSimCard =
      isMainSimCard && !hasSimCardTask && customerType !== 1
    let hasExtraSimCards = extraSimCards && extraSimCards.length > 0
    let canActivate =
      hasSimCardTask &&
      !simCardTasks[0].activationDate &&
      simCardTasks[0].status == 1
    let pinLetterUrl = getApiUrl() + '/pinLetter/' + id

    return (
      <div className='mp-tile c-sim-card'>
        {hasExtraSimCards
          ? this.renderSimCardList(simCard, extraSimCards, currentSimCard)
          : null}
        <h2 className='h5 color-dark-blue'>{lang.simCard.title}</h2>
        {hasSimCardTask ? (
          <p className='mp-task-info'>
            {format(
              lang.simCard.activeOrder,
              formatDate(simCardTasks[0].created, 'LL')
            )}
          </p>
        ) : null}
        {hasExtraSimCardTask ? (
          <p className='mp-task-info'>
            {format(
              lang.simCard.activeExtraOrder,
              formatDate(extraSimCardTasks[0].created, 'LL')
            )}
          </p>
        ) : null}
        <p>
          <strong>{lang.simCard.iccId}</strong>
          <br />
          {iccId}
        </p>
        <div className='mp-block'>
          <p className='mp-block-half'>
            <strong>{lang.simCard.pinCode}</strong>
            <br />
            {pinCode} <Tooltip tip={lang.simCard.pinNote} />
          </p>
          <p className='mp-block-half'>
            <strong>{lang.simCard.pukCode}</strong>
            <br />
            {pukCode}
          </p>
        </div>
        <div>
          {canActivate ? (
            <a href='#' className='link' onClick={this.showActivate}>
              {lang.simCard.activate.button}
            </a>
          ) : null}
          {canOrderSimCard ? (
            <a href='#' className='link' onClick={this.showDialog}>
              {lang.simCard.order}
            </a>
          ) : null}
          {canOrderExtraSimCard ? (
            <a href='#' className='link' onClick={this.showExtraDialog}>
              {lang.simCard.orderExtra}
            </a>
          ) : null}
          <a href={pinLetterUrl} className='link'>
            {lang.simCard.printPinLetter}
          </a>
        </div>
        {showDialog ? (
          <SimCardDialog
            onSubmit={this.orderSimCard}
            onClose={this.hideDialog}
            price={simCardPrice}
          />
        ) : null}
        {showExtraDialog ? (
          <SimCardExtraDialog
            onSubmit={this.orderExtraSimCard}
            onClose={this.hideExtraDialog}
            price={extraSimCardPrice}
          />
        ) : null}
        {showActivate ? (
          <SimCardActivateDialog
            onConfirm={this.activateSimCard}
            onCancel={this.hideActivate}
          />
        ) : null}
      </div>
    )
  }

  renderSimCardList(simCard, extraSimCards, currentSimCard) {
    this.simCards = [{ label: 'Huvudkort', value: simCard.id }].concat(
      extraSimCards.map(function (extraSimCard) {
        return { label: extraSimCard.iccId, value: extraSimCard.id }
      })
    )

    let selectedSimCard = this.simCards.find(function (option) {
      return option.value === currentSimCard.id
    })

    return (
      <div className='mp-simcard-list'>
        <Select
          options={this.simCards}
          value={selectedSimCard}
          searchable={false}
          clearable={false}
          autoBlur={true}
          onChange={this.selectSimCard}
        />
      </div>
    )
  }

  selectSimCard = value => {
    let { simCardInfo } = this.props
    let { simCard, extraSimCards } = simCardInfo

    let selectedSimCard = extraSimCards
      .concat(simCard)
      .find(function (simCard) {
        return simCard.id === value
      })

    this.setState({ currentSimCard: selectedSimCard })
  }

  orderSimCard = activationTime => {
    this.props.orderSimCard(activationTime)
    this.setState({ showDialog: false })
  }

  orderExtraSimCard = activationTime => {
    this.props.orderExtraSimCard(activationTime)
    this.setState({ showExtraDialog: false })
  }

  activateSimCard = ev => {
    ev.preventDefault()
    this.props.activateSimCard()
    this.setState({ showActivate: false })
  }

  showDialog = ev => {
    ev.preventDefault()
    this.setState({ showDialog: true })
  }

  hideDialog = ev => {
    ev.preventDefault()
    this.setState({ showDialog: false })
  }

  showExtraDialog = ev => {
    ev.preventDefault()
    this.setState({ showExtraDialog: true })
  }

  hideExtraDialog = ev => {
    ev.preventDefault()
    this.setState({ showExtraDialog: false })
  }

  showActivate = ev => {
    ev.preventDefault()
    this.setState({ showActivate: true })
  }

  hideActivate = ev => {
    ev.preventDefault()
    this.setState({ showActivate: false })
  }
}

SimCard.propTypes = {
  simCardInfo: PropTypes.object.isRequired,
  orderSimCard: PropTypes.func.isRequired,
  orderExtraSimCard: PropTypes.func.isRequired,
  activateSimCard: PropTypes.func.isRequired,
}
